import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { PreloaderColor, UiPreloaderComponent } from '../ui-preloader/ui-preloader.component';

@Component({
  selector: 'ui-refresh-button',
  templateUrl: './ui-refresh-button.component.html',
  styleUrl: './ui-refresh-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, UiPreloaderComponent],
})
export class UiRefreshButtonComponent {
  private readonly translate = inject(TranslateService);

  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  tooltip = input<string>('');

  clicked = output<void>();

  protected readonly resolvedTooltip = computed(
    () => this.tooltip() || this.translate.instant('COMMON.REFRESH'),
  );
  protected readonly PreloaderColor = PreloaderColor;

  onClick(): void {
    if (!this.loading() && !this.disabled()) {
      this.clicked.emit();
    }
  }
}
